import { createContext, useContext } from "react";
import { DocsPdf } from "@maven-rest/docs/pdf/DocsPdf.dto";

interface DocsPdfContextProps {
  docsPdf: Pick<DocsPdf, "id" | "metainfo"> | null;
}

const DocsPdfContext = createContext<DocsPdfContextProps>({
  docsPdf: null,
});

function DocsPdfContextProvider({ docsPdf, children }: { docsPdf: Pick<DocsPdf, "id" | "metainfo">; children: React.ReactNode }) {
  return <DocsPdfContext.Provider value={{ docsPdf }}>{children}</DocsPdfContext.Provider>;
}

function useDocsPdfContext() {
  const docsPdfContext = useContext(DocsPdfContext);

  if (!docsPdfContext) {
    throw Error("useDocsPdfContext is must use within DocsPdfContext");
  }

  return docsPdfContext;
}

export { DocsPdfContext, DocsPdfContextProvider, useDocsPdfContext };
